export enum BusinessAttributeKind {
  Vertical = 'Vertical',
  Role = 'Role',
  Discipline = 'Discipline',
  Function = 'Function',
}
